module.exports = __webpack_public_path__ + "static/media/MultiDRM.1eebe908.png";